import "../styles/Legal.css";

export default function LegalNotice() {
  return (
    <div className="legal-page">
      <h1>Lege-oharra</h1>

      <p>
        Informazioaren Gizarteko Zerbitzuei eta Merkataritza Elektronikoari
        buruzko araudia betez, webgune honen identifikazio datuak honako hauek
        dira:
      </p>

      <h2>Titularra</h2>
      <p>Alaiak Mungialdeko Soinulari Elkartea</p>

      <h2>Harremanetarako posta elektronikoa</h2>
      <p>soinulariakmungia@alaiak.eus</p>

      <h2>Webgunearen helburua</h2>
      <p>
        Webgune honen helburua elkartearen jarduerei, ekitaldiei eta edukiei
        buruzko informazioa eskaintzea da, baita erabiltzaileekin harremanetan
        jartzea erraztea ere.
      </p>

      <h2>Erabilera-baldintzak</h2>
      <p>
        Webgune honetara sartzeak erabiltzaile izaera ematen du, eta bertan
        jasotako baldintzak onartzea dakar. Erabiltzaileak konpromisoa hartzen
        du webgunea, bere edukiak eta zerbitzuak modu egokian erabiltzeko, legea,
        fede ona eta ordena publikoa errespetatuz.
      </p>
      <p>
        Debekatuta dago webguneko edukiak legez kontrako helburuetarako edo
        hirugarrenen eskubideak kaltetu ditzaketen jardueretarako erabiltzea.
      </p>

      <h2>Edukien erantzukizuna</h2>
      <p>
        Alaiak Mungialdeko Soinulari Elkarteak ahalegina egiten du webguneko
        informazioa eguneratua eta zuzena izan dadin; hala ere, ez du bermatzen
        edukietan akatsik edo omisiorik ez dagoenik.
      </p>
      <p>
        Titularra ez da izango webgune honetan jasotako informazioaren
        erabileratik sor daitezkeen kalteen erantzule.
      </p>

      <h2>Kanpo-estekak</h2>
      <p>
        Webgune honek hirugarrenen webguneetarako estekak izan ditzake. Elkarteak
        ez du bere gain hartzen kanpo-webgune horietako edukien, politiken edo
        funtzionamenduaren gaineko erantzukizunik.
      </p>

      <h2>Jabetza intelektuala eta industriala</h2>
      <p>
        Webgune honetako testu, irudi, diseinu, logo, fitxategi eta gainerako
        eduki guztiak Alaiak Mungialdeko Soinulari Elkartearenak dira edo behar
        bezala erabiltzeko baimena dute, eta jabetza intelektual eta industrialeko
        eskubideek babestuta daude.
      </p>
      <p>
        Debekatuta dago eduki horien erreprodukzioa, banaketa edo eraldaketa,
        titularraren aldez aurreko eta berariazko baimenik gabe.
      </p>

      <h2>Araudi aplikagarria</h2>
      <p>
        Webgune honen erabilera Espainiako indarreko araudiaren menpe dago.
      </p>
    </div>
  );
}